<template>
  <div class="row">
    <div class="col-md-12">
      <el-checkbox v-model="settings.Avod" size="medium">
        <p>AVOD</p>
      </el-checkbox>
      <div class="table-responsive table-full-width" v-if="settings.Avod">
        <el-table
          ref="multipleTable"
          :data="tableData"
          @select-all="handleSelectionAllChange"
        >
          <el-table-column type="selection" width="80">
            <template slot-scope="props">
              <l-checkbox
                :checked="isChecked(props)"
                @input="checkChanged($event, props)"
              ></l-checkbox>
            </template>
          </el-table-column>

          <el-table-column label="Title" property="title"></el-table-column>

          <el-table-column
            label="Description"
            property="description"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox as LCheckbox } from "src/components";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import { Table, TableColumn, Checkbox } from "element-ui";
import countries from "../../../config/countries.json";

export default {
  props: ["setting", "createmode"],
  components: {
    LCheckbox,
    bModal,
    bModalDirective,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Checkbox.name]: Checkbox
  },
  created() {},
  mounted() {
    this.settings = this.setting;

    this.$store
      .dispatch("getAvodConfigList")
      .then(data => {
        this.tableData = data.data;
        this.sIds = JSON.parse(JSON.stringify(this.settings.avodConfigIds));
        if (!this.createmode) {
          if (this.settings.avodConfigIds) {
            if (this.settings.avodConfigIds.length == this.tableData.length) {
              this.$refs.multipleTable.toggleAllSelection();
            }
          }
        }
      })
      .catch(() => {});
  },
  data() {
    return {
      show: false,
      shown: false,
      settings: {
        avodConfigIds: []
      },
      tableData: [],
      sIds: [],
      countries: [],
      checkedSvod: true
    };
  },
  watch: {
    setting: function() {
      this.settings = this.setting;
      if (this.settings.avodConfigIds) {
        this.sIds = JSON.parse(JSON.stringify(this.settings.avodConfigIds));
      }
    }
  },
  methods: {
    handleEdit: function(evt) {
      evt.preventDefault();
      this.$refs.subscriptionSelection.show();
      this.sIds = JSON.parse(JSON.stringify(this.settings.avodConfigIds));

      // this.$refs.multipleTable.clearSelection();
      // if(this.settings.avodConfigIds) {
      //     this.sIds = JSON.parse(JSON.stringify(this.settings.avodConfigIds));
      //     if(this.sIds.length == this.tableData.length) {
      //         this.$refs.multipleTable.toggleAllSelection();
      //         return;
      //     }
      //     this.$nextTick(() => {
      //         for(var i=0;i<this.sIds.length;i++) {
      //             var id = this.sIds[i];
      //             var index = this.findWithAttr(this.tableData,"id",id);
      //             if(index>=0) {
      //                 this.$refs.multipleTable.toggleRowSelection(this.tableData[index]);
      //             }
      //         }
      //     })

      // }
    },
    isChecked(props) {
      if (this.sIds) {
        return this.sIds.includes(props.row.id);
      }
      return false;
    },
    handleNewConfigOk: function() {
      this.settings.avodConfigIds = JSON.parse(JSON.stringify(this.sIds));
    },
    handleShown: function() {},
    getSettingInfo: function() {
      this.settings.avodConfigIds = this.sIds;
      return this.sIds;
    },
    checkChanged: function(val, props) {
      this.$refs.multipleTable.clearSelection();
      if (!this.sIds || !Array.isArray(this.sIds)) {
        this.sIds = [];
      }
      var id = props.row.id;
      if (id) {
        if (val) {
          if (!this.sIds.includes(id)) {
            this.sIds.push(id);
          }
        } else {
          if (this.sIds.includes(id)) {
            var index = this.sIds.indexOf(id);
            this.sIds.splice(index, 1);
          }
        }
        if (this.sIds.length == this.tableData.length) {
          this.$refs.multipleTable.toggleAllSelection();
        }
      }
    },
    handleSelectionAllChange: function(val) {
      if (val.length == 0) {
        this.sIds = [];
      } else {
        for (var i = 0; i < this.tableData.length; i++) {
          this.sIds.push(this.tableData[i].id);
        }
      }
    },
    findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    getPriceCurrency: function(row) {
      var price = row.price;
      var currency = row.currency;
      return price + "   " + currency;
    },
    getMultiCountryName: function(row) {
      var countries = row.country;
      var str = "";
      if (Array.isArray(countries)) {
        for (var i = 0; i < countries.length; i++) {
          var country = countries[i];
          var cvar = this.countries.find(function(element) {
            return element.value == country;
          });
          if (cvar) {
            if (i != 0) {
              str = str + " , ";
            }
            str = str + cvar.label;
          }
        }
      }
      return str;
    }
  }
};
</script>

<style>
.btn-select {
  color: #ff0000;
  padding-left: 15px;
}

.largepopup {
  width: 750px;
}

label.el-checkbox {
  margin-left: 4px !important;
}
.checkItem {
  margin-left: 0px !important;
}
</style>
